module.exports = __webpack_public_path__ + "img/bk_18_04.d91e3a03.png";